export interface StageConfigEntry {
  timeLimitSec: number;
  requiredHits: number;
  radiusPxMin: number;
  radiusPxMax: number;
  targetMove: "static" | "linear";
  targetSpeedPxPerSec: number;
  objectCount: number;
  stageScoreThreshold: number;
}

export const STAGES: StageConfigEntry[] = [
  {
    timeLimitSec: 35,
    requiredHits: 6,
    radiusPxMin: 70,
    radiusPxMax: 80,
    targetMove: "static",
    targetSpeedPxPerSec: 0,
    objectCount: 1,
    stageScoreThreshold: 800,
  },
  {
    timeLimitSec: 35,
    requiredHits: 7,
    radiusPxMin: 65,
    radiusPxMax: 75,
    targetMove: "static",
    targetSpeedPxPerSec: 0,
    objectCount: 1,
    stageScoreThreshold: 1100,
  },
  {
    timeLimitSec: 40,
    requiredHits: 8,
    radiusPxMin: 60,
    radiusPxMax: 70,
    targetMove: "linear",
    targetSpeedPxPerSec: 50,
    objectCount: 1,
    stageScoreThreshold: 1500,
  },
];
